import { useEffect, useState } from 'react';

const useIsOnScreen = ref => {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = new window.IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.disconnect();
      }
    };
  }, [observer, ref]);

  return isIntersecting;
};

export { useIsOnScreen };
